const MEDIA_ITEMS = [
  {
    title: '韩漫推荐：暑期必追恋愛番合集',
    desc: '盘点各大韩漫平台暑期最热恋爱题材，甜蜜指数爆表',
    duration: '15:24',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20romantic%20illustration%20of%20a%20couple%20reading%20comics%20together%20in%20a%20cozy%20cafe%20with%20soft%20natural%20light%2C%20cream%20and%20blush%20pink%20color%20palette%2C%20gentle%20illustration%20style%2C%20intimate%20atmosphere&width=640&height=400&seq=media-01-2026&orientation=landscape',
    tag: '韩漫推荐',
  },
  {
    title: '韩漫之家平台使用攻略全解析',
    desc: '手把手教你玩转韩漫之家，追更收藏一键搞定',
    duration: '22:10',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20flat%20illustration%20of%20a%20tablet%20showing%20a%20comic%20reader%20interface%20with%20colorful%20panels%2C%20warm%20beige%20background%2C%20clean%20and%20friendly%20design%2C%20tutorial%20concept%20with%20gentle%20warm%20tones&width=640&height=400&seq=media-02-2026&orientation=landscape',
    tag: '使用攻略',
  },
  {
    title: '2026韩漫圈年度热门作品大盘点',
    desc: '回顾今年最受漫迷欢迎的韩漫作品与平台动态',
    duration: '18:45',
    image: 'https://readdy.ai/api/search-image?query=A%20playful%20illustration%20of%20a%20trophy%20and%20comic%20books%20with%20confetti%20on%20a%20warm%20cream%20background%2C%20celebration%20and%20award%20concept%2C%20flat%20illustration%20style%20with%20soft%20colors%2C%20editorial%20quality&width=640&height=400&seq=media-03-2026&orientation=landscape',
    tag: '年度盘点',
  },
  {
    title: '韩漫屋vs韩漫网：选择困难看这里',
    desc: '两大热门韩漫网站深度对比，助你找到最适合的平台',
    duration: '12:38',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20side%20by%20side%20comparison%20illustration%20with%20two%20screens%20showing%20different%20comic%20styles%2C%20warm%20neutral%20beige%20background%2C%20modern%20minimalist%20flat%20design%2C%20professional%20editorial%20quality&width=640&height=400&seq=media-04-2026&orientation=landscape',
    tag: '平台对比',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩内容
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            韩漫相关精选内容与专题视频，助您深入了解韩漫世界
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 bg-foreground-950/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <span className="text-[10px] bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full font-medium">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mt-2 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}